import { useState, useCallback } from "react";
import axiosInstance from "services/httpInterceptor";

const useQuickCatchupData = (source, options = {}) => {
  const { competitorId, pressId } = options;
  const [briefing, setBriefing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    const canFetch = (source === "news" && pressId !== undefined) || competitorId;

    if (!canFetch) {
      setBriefing(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    setBriefing(null); // Clear previous results before a new fetch.

    try {
      let endpoint;
      const params = {};

      switch (source) {
        case "news":
          endpoint = "/v1/reports/news-catchup";
          if (pressId) {
            params.source = pressId;
          }
          break;
        case "products":
          endpoint = "/v1/reports/products-catchup";
          params.competitorId = competitorId;
          break;
        case "digital-presence":
          endpoint = "/v1/reports/quick-catchup";
          params.competitorId = competitorId;
          break;
        default:
          throw new Error(`Invalid quick catchup source: ${source}`);
      }

      const response = await axiosInstance.get(endpoint, { params });
      
      let data;
      switch (source) {
        case "news":
          data = response.data.notableNewsSummary;
          break;
        case "products":
          data = response.data.productsCatchupSummary;
          break;
        case "digital-presence":
          data = response.data.competitorBriefing;
          break;
      }

      setBriefing(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [competitorId, pressId, source]);

  return { briefing, loading, error, fetchData };
};

export default useQuickCatchupData; 